import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExpoListLayer from "../components/ExpoListLayer";

const ExpoListPage = () => {
    return (
        <MasterLayout>
            <ExpoListLayer />
        </MasterLayout>
    );
};

export default ExpoListPage;
